import maDamageTypeBtn from '@/components/buttons'
import maNavbarCategorySpecific from '@/components/navbarCategoriesSpecific'
import { mapState, mapMutations, mapActions } from 'vuex'
import { apiGetMenus } from '@/modules/Damage/services/menus'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_UPDATE_ID,
  WARRANTY_UPDATE_ID_CATEGORY_SUBTYPE,
  WARRANTY_GET_SINISTER,
  WARRANTY_UPDATE_DAMAGED_ITEM,
  WARRANTY_UPDATE_DAMAGE_TYPE_LITERAL,
  WARRANTY_UPDATE_IS_MULTIDAMAGE,
  WARRANTY_UPDATE_MULTIDAMAGE,
  WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { OTHERS } from '@/constants'

export default {
  name: 'damagesTypes',

  mixins: [flowMixin],

  data: function () {
    return {
      /**
       * Array retrieved from the apiGetForms service which contains the info of all the damage types.
       */
      dataDamageTypes: []
    }
  },

  components: {
    maDamageTypeBtn,
    maNavbarCategorySpecific
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyReport: 'report',
      stateWarrantyForms: 'forms'
    })
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyUpdateId: WARRANTY_UPDATE_ID,
      mutWarrantyUpdateIdCategorySubtype: WARRANTY_UPDATE_ID_CATEGORY_SUBTYPE,
      mutWarrantyUpdateDamagedItem: WARRANTY_UPDATE_DAMAGED_ITEM,
      mutWarrantyUpdateDamageTypeLiteral: WARRANTY_UPDATE_DAMAGE_TYPE_LITERAL,
      mutWarrantyUpdateIsMultidamage: WARRANTY_UPDATE_IS_MULTIDAMAGE,
      mutWarrantyUpdateMultidamage: WARRANTY_UPDATE_MULTIDAMAGE,
      mutWarrantyClearSelectedDamagedParts: WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS,
      actWarrantyGetSinister: WARRANTY_GET_SINISTER
    }),

    handleGoToDamagesView() {
      const damagesViewViewName = 'damages-view'
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReport()
      this.goToView(damagesViewViewName)
    },

    /**
     * Updates the report state, clears forms state,  and calls the action actWarrantyGetForms, pushes the params for the next route
     */
    handleClickDamageType(damageType, damageLiteral) {
      const value = damageType
      const key = this.dataDamageTypes.name
      const propertyType = this.getPropertyType

      this.mutWarrantyUpdateReport({ key, value })
      this.mutWarrantyUpdateDamageTypeLiteral(damageLiteral)
      localStorage.setItem('damageTypeLiteral', damageLiteral)

      switch (damageType) {
        case 'RECHERCHE_FUITE_NETTOYAGE':
          const damagedItem = 'RECHERCHE_FUITE_NETTOYAGE'
          const damagedPartsViewName = 'damaged-parts'
          this.mutWarrantyUpdateDamagedItem('Recherche de Fuite/Nettoyage')
          this.goToView(damagedPartsViewName, {
            propertyType,
            damageType,
            damagedItem
          })
          break

        case 'BIENS_IMMOBILIERS':
          const damageMobilierViewName = 'damageMobilier'
          this.goToView(damageMobilierViewName, { propertyType, damageType })
          break

        default:
          if (damageType === OTHERS) {
            this.mutWarrantyClearSelectedDamagedParts()
          }
          const damagedItemsViewName = 'damaged-items'
          this.goToView(damagedItemsViewName, { propertyType, damageType })
          break
      }
    },
    trackFlowStartDamage() {
      const startTrackMessage = `Selfcare - View part damages`
      this.trackUserFlowTimeStamp(startTrackMessage, this.getSinisterId)
    },
    /**
     * Updates the state report, gets the id, category and subtype of the general form, calls action actWarrantyGetForms to get the froms and updates the data property dataDamagesTypes with the required forms
     */
    getForm() {
      const key = 'propertyType'
      const value = this.getPropertyType

      this.mutWarrantyUpdateReport({ key, value })

      apiGetMenus()
        .then((menuData) => {
          menuData.forEach((menu) => {
            const warrantyId = this.getWarrantyId

            menu.children.forEach((child) => {
              if (parseInt(child.id) === parseInt(warrantyId)) {
                const category = warrantyId
                const subtype = child.warranty_subtype_id
                localStorage.setItem('warranty_subtype_id', subtype)
                this.mutWarrantyUpdateIdCategorySubtype({ category, subtype })
                this.mutWarrantyUpdateId(warrantyId)
              } else {
                const category = warrantyId
                const subtype = '1'
                localStorage.setItem('warranty_subtype_id', subtype)
                this.mutWarrantyUpdateIdCategorySubtype({ category, subtype })
                this.mutWarrantyUpdateId(warrantyId)
              }
            })
          })
        })
        .then(() => {
          const report = this.stateWarrantyReport
          const warrantyId = this.getWarrantyId
          this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
            if (resp.formsUpdated) {
              const inputs = this.stateWarrantyForms[0].form.regions[0].inputs
              const filteredInputs = inputs.filter((input) => {
                return input.type !== 'hidden'
              })

              this.dataDamageTypes = filteredInputs[0]
            }
          })
        })
    }
  },

  /**
   * Clears froms and report state, executes the function get form
   */
  mounted() {
    const sinisterId = this.getSinisterId

    this.actWarrantyGetSinister(sinisterId).then((resp) => {
      if (!resp.isSinisterFound) {
        this.throwNotification(
          this.$t('notifications.loadSinisterKO.title'),
          this.$t('notifications.loadSinisterKO.body'),
          'KO'
        )
      }
    })
    this.mutWarrantyClearForms()
    this.mutWarrantyClearReport()
    this.mutWarrantyUpdateIsMultidamage(false)
    this.mutWarrantyUpdateMultidamage({})
    this.getForm()
    this.trackFlowStartDamage()
  }
}
